export const HOME = "/";
export const RECHERCHE = "/recherche";
export const ANNONCE_DETAIL = "/annonce/:id";
export const TEXTES_DE_LOI = "/textes-de-loi";
export const AIDE = "/aide";

// Auth routes
export const LOGIN = "/connexion";
export const REGISTER = "/inscription";
export const FORGOT_PASSWORD = "/mot-de-passe-oublie";
export const RESET_PASSWORD = "/reinitialiser-mot-de-passe/:uid?/:token?";
export const VERIFICATION_OTP = "/verification-otp/:type?";
